"use client";

import { spanishChromeLabel, translationSourceHash } from "@repo/questionnaire";

import {
  BusinessTypeCombobox,
  type BusinessTypeOption,
} from "@/components/listings/business-type-combobox";
import { Input } from "@/components/ui/input";

export function IntakeBusinessTypeField({
  id,
  searchable = false,
  label,
  value,
  onChange,
  disabled,
  error,
  translations,
  locale = "en",
}: {
  id: string;
  searchable?: boolean;
  label: string;
  value?: BusinessTypeOption | string | null;
  onChange: (value: BusinessTypeOption | string) => void;
  disabled?: boolean;
  error?: string;
  translations?: Record<string, string>;
  locale?: string;
}) {
  const translatedLabel =
    locale === "en"
      ? label
      : (translations?.[translationSourceHash(label)] ??
        (locale === "es" ? spanishChromeLabel(label) : label));

  if (searchable)
    return (
      <fieldset
        id={id}
        aria-label={translatedLabel}
        aria-describedby={error ? `${id}-error` : undefined}
      >
        <BusinessTypeCombobox
          value={
            typeof value === "string"
              ? value
                ? { id: -1, name: value }
                : null
              : value
          }
          onChange={onChange}
          onUnresolvedText={onChange}
          disabled={disabled}
          locale={locale}
          translations={translations}
          placeholder="Search business types"
          inputContainerClassName="min-h-12"
        />
      </fieldset>
    );
  return (
    <Input
      id={id}
      type="text"
      aria-label={translatedLabel}
      aria-invalid={Boolean(error)}
      aria-describedby={error ? `${id}-error` : undefined}
      value={typeof value === "string" ? value : (value?.name ?? "")}
      minLength={2}
      disabled={disabled}
      className="h-12 text-base md:text-base"
      onChange={(event) => onChange(event.target.value)}
    />
  );
}
